export const getSizeCssClass = (
  size: 'normal' | 'small' | 'tiny' | undefined,
  tagName: string,
): string => {
  switch (size) {
    case 'small':
      return `${tagName}--small`;
    case 'tiny':
      return `${tagName}--tiny`;
    default:
      return '';
  }
};
